import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditRfiOrganizationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIOrganization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import {
  EditOrganizationModalBody,
  EditOrganizationModalValues,
} from './components/EditOrganizationModalBody'

export function useEditOptions(): EditRowActionOptions<
  RFIOrganization,
  EditOrganizationModalValues
> {
  const { refetch } = useOrganizationsTableContext()
  const [editOrganization] = useEditRfiOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editRFIOrganization: {
        organization: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditRFIOrganization,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <EditOrganizationModalBody />,
      initialValues: ({ name, description }) => {
        return { name, description }
      },
      onOk: async (
        { id, name: prevName, description: prevDescription },
        { name, description }
      ) => {
        if (prevName !== name || prevDescription !== description) {
          await editOrganization({
            variables: { editRfiOrganizationInput: { id, name, description } },
          })
          await refetch()
        }
      },
    },
  }
}
